module.exports = __webpack_public_path__ + "img/12.c3ab0a50.png";